<template>
  <div>
    <div
      v-if="display"
      class="sensitive text-center text-lg font-mono tracking-widest mb-2 select-all"
      :class="dark ? 'text-gray-200' : 'text-neutral-800'"
    >{{ display }}</div>
    <div class="grid grid-cols-3 gap-1.5">
      <button
        v-for="key in keys"
        :key="key.digit"
        type="button"
        class="rounded-lg transition-colors flex flex-col items-center justify-center select-none"
        :class="dark
          ? 'h-12 bg-gray-700 hover:bg-gray-600 active:bg-gray-500'
          : 'h-11 bg-gray-100 hover:bg-gray-200 active:bg-gray-300'"
        :aria-label="`Dial ${key.digit}`"
        @click="$emit('press', key.digit)"
      >
        <span class="text-base font-semibold leading-none" :class="dark ? 'text-white' : 'text-neutral-900'">{{ key.digit }}</span>
        <span v-if="key.sub" class="text-[9px] leading-none mt-0.5 tracking-wider text-gray-400">{{ key.sub }}</span>
      </button>
    </div>
  </div>
</template>

<script>
const KEYS = [
  { digit: '1', sub: '' },
  { digit: '2', sub: 'ABC' },
  { digit: '3', sub: 'DEF' },
  { digit: '4', sub: 'GHI' },
  { digit: '5', sub: 'JKL' },
  { digit: '6', sub: 'MNO' },
  { digit: '7', sub: 'PQRS' },
  { digit: '8', sub: 'TUV' },
  { digit: '9', sub: 'WXYZ' },
  { digit: '*', sub: '' },
  { digit: '0', sub: '+' },
  { digit: '#', sub: '' },
]

export default {
  name: 'DialKeypad',
  props: {
    display: { type: String, default: '' },
    dark: { type: Boolean, default: false },
  },
  emits: ['press'],
  data() {
    return { keys: KEYS }
  },
}
</script>
